var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "event" } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showInvitationAttendanceInConfirmation
          ? _c("div", { staticClass: "alertBox" }, [
              _c("div", [
                _c("h5", [_vm._v("Change Attendance")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Glad you're able to attend. Change your attendance to IN?"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "destructive",
                    on: {
                      click: function($event) {
                        _vm.showInvitationAttendanceInConfirmation = false
                      }
                    }
                  },
                  [_vm._v("No")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        _vm.showInvitationAttendanceInConfirmation = false
                        _vm.updateInvitationAttendanceStatus(
                          _vm.selectedEvent,
                          _vm.appUser,
                          1
                        )
                      }
                    }
                  },
                  [_vm._v("Yes")]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showInvitationAttendanceInPlusOneConfirmation
          ? _c("div", { staticClass: "alertBox" }, [
              _c("div", [
                _c("h5", [_vm._v("Change Attendance")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Glad you're able to attend...with a friend! Change your attendance to IN plus one?"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "destructive",
                    on: {
                      click: function($event) {
                        _vm.showInvitationAttendanceInPlusOneConfirmation = false
                      }
                    }
                  },
                  [_vm._v("No")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        _vm.showInvitationAttendanceInPlusOneConfirmation = false
                        _vm.updateInvitationAttendanceStatus(
                          _vm.selectedEvent,
                          _vm.appUser,
                          2
                        )
                      }
                    }
                  },
                  [_vm._v("Yes")]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showInvitationAttendanceOutConfirmation
          ? _c("div", { staticClass: "alertBox" }, [
              _c("div", [
                _c("h5", [_vm._v("Change Attendance")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Too bad you can't make it. Change your attendance to OUT?"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "destructive",
                    on: {
                      click: function($event) {
                        _vm.showInvitationAttendanceOutConfirmation = false
                      }
                    }
                  },
                  [_vm._v("No")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        _vm.showInvitationAttendanceOutConfirmation = false
                        _vm.updateInvitationAttendanceStatus(
                          _vm.selectedEvent,
                          _vm.appUser,
                          3
                        )
                      }
                    }
                  },
                  [_vm._v("Yes")]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.eventCalloutText(_vm.selectedEvent, false)
        ? _c(
            "div",
            { class: _vm.eventCalloutContainerStyle(_vm.selectedEvent) },
            [
              _c("div", { staticClass: "callout" }, [
                _vm.eventCalloutText(_vm.selectedEvent, true)
                  ? _c("span", { staticClass: "calloutFragment" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .eventCalloutText(_vm.selectedEvent, false)
                            .toUpperCase()
                        )
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedEvent
        ? _c("div", { attrs: { id: "eventContent" } }, [
            _vm.selectedEvent.mediaItems &&
            _vm.selectedEvent.mediaItems.length > 0
              ? _c(
                  "div",
                  { staticClass: "mediaItemList" },
                  [
                    _c(
                      "vue-horizontal",
                      {
                        ref: "horizontal",
                        staticClass: "horizontal",
                        attrs: { "button-between": false },
                        on: { "scroll-debounce": _vm.onScrollDebounce }
                      },
                      _vm._l(_vm.selectedEvent.mediaItems, function(
                        mediaItem,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "mediaContainer" },
                          [
                            mediaItem.type == _vm.$MediaItemType.video
                              ? _c("div", [
                                  _c(
                                    "video",
                                    {
                                      staticClass: "media",
                                      attrs: {
                                        preload: "auto",
                                        controls: "",
                                        autoplay: "",
                                        playsinline: "",
                                        muted: ""
                                      },
                                      domProps: { muted: true }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: mediaItem.link,
                                          type: "video/mp4"
                                        }
                                      }),
                                      _vm._v(
                                        "\n              Your browser does not support the video tag.\n            "
                                      )
                                    ]
                                  )
                                ])
                              : _c("div", [
                                  _c("img", {
                                    staticClass: "media",
                                    attrs: { src: mediaItem.link }
                                  })
                                ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mediaCredit" }, [
                              mediaItem.creator.givenName
                                ? _c("span", [
                                    _vm._v(_vm._s(mediaItem.creator.givenName))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              mediaItem.creator.givenName
                                ? _c("span", [
                                    _vm._v(_vm._s(mediaItem.creator.familyName))
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedEvent.mediaItems &&
            _vm.selectedEvent.mediaItems.length > 1
              ? _c(
                  "div",
                  { staticClass: "pageControl" },
                  _vm._l(_vm.pages, function(i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "dot",
                        class: { current: i - 1 === _vm.index },
                        on: {
                          click: function($event) {
                            return _vm.onPageTapped(
                              i - 1,
                              _vm.selectedEvent.mediaItems
                            )
                          }
                        }
                      },
                      [_c("div")]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("section", [
              _c("div", { staticClass: "row name" }, [
                _vm._v(_vm._s(_vm.selectedEvent.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticStyle: { position: "relative" } }, [
                  _c("img", {
                    staticClass: "colorizePrimary",
                    attrs: {
                      src: require("../assets/images/EventDetail_WhenIcon.png"),
                      width: "35",
                      height: "30"
                    }
                  }),
                  _vm._v(" "),
                  _vm.isChangeStatusSetForUserInvitation(
                    _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser),
                    _vm.$InvitationChangeStatus.eventDateChanged
                  ) ||
                  _vm.isChangeStatusSetForUserInvitation(
                    _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser),
                    _vm.$InvitationChangeStatus.eventTimeChanged
                  )
                    ? _c("div", [
                        _c("div", {
                          staticClass: "statusDotBackground",
                          staticStyle: {
                            position: "absolute",
                            top: "-8px",
                            right: "-8px"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "statusDot",
                          staticStyle: {
                            position: "absolute",
                            top: "-5px",
                            right: "-5px"
                          }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "heading" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formattedDateTimeString(
                        _vm.selectedEvent.dateTime.toDate(),
                        _vm.selectedEvent.location,
                        _vm.appUser.timeZoneIdentifier
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.selectedEvent.location
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticStyle: { position: "relative" } }, [
                      _c("img", {
                        staticClass: "colorizePrimary",
                        attrs: {
                          src: require("../assets/images/EventDetail_WhereIcon.png"),
                          width: "35",
                          height: "30"
                        }
                      }),
                      _vm._v(" "),
                      _vm.isChangeStatusSetForUserInvitation(
                        _vm.invitationForAppUser(
                          _vm.selectedEvent,
                          _vm.appUser
                        ),
                        _vm.$InvitationChangeStatus.eventLocationChanged
                      )
                        ? _c("div", [
                            _c("div", {
                              staticClass: "statusDotBackground",
                              staticStyle: {
                                position: "absolute",
                                top: "-8px",
                                right: "-8px"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "statusDot",
                              staticStyle: {
                                position: "absolute",
                                top: "-5px",
                                right: "-5px"
                              }
                            })
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "heading" }, [
                      _vm._v(
                        _vm._s(_vm.selectedEvent.location.name) +
                          " (" +
                          _vm._s(_vm.selectedEvent.location.cityState) +
                          ") "
                      ),
                      _vm.selectedEvent.weatherForecast
                        ? _c(
                            "span",
                            { staticClass: "material-symbols-outlined" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.googleWeatherSymbolForSfSymbol(
                                    _vm.selectedEvent.weatherForecast
                                      .forecastSymbolName
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedEvent.weatherForecast
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedEvent.weatherForecast
                                  .forecastTemperatureFormatted
                              ) +
                                " " +
                                _vm._s(
                                  _vm.selectedEvent.weatherForecast
                                    .forecastPrecipitationChanceFormatted
                                )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "material-symbols-outlined-small" },
                        [_vm._v("humidity_high")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedEvent.messages &&
              _vm.selectedEvent.messages.length > 0
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticStyle: { position: "relative" } }, [
                      _c("img", {
                        staticClass: "colorizePrimary",
                        attrs: {
                          src: require("../assets/images/EventDetail_MessageIcon.png"),
                          width: "35",
                          height: "30"
                        }
                      }),
                      _vm._v(" "),
                      _vm.isChangeStatusSetForUserInvitation(
                        _vm.invitationForAppUser(
                          _vm.selectedEvent,
                          _vm.appUser
                        ),
                        _vm.$InvitationChangeStatus.eventMessagesAdded
                      )
                        ? _c("div", [
                            _c("div", {
                              staticClass: "statusDotBackground",
                              staticStyle: {
                                position: "absolute",
                                top: "-8px",
                                right: "-8px"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "statusDot",
                              staticStyle: {
                                position: "absolute",
                                top: "-5px",
                                right: "-5px"
                              }
                            })
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col1" }, [
                      _c("p", { staticClass: "heading" }, [
                        _vm._v(
                          "Messages (" +
                            _vm._s(
                              _vm.selectedEvent.messages &&
                                _vm.selectedEvent.messages.length
                            ) +
                            ")"
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedEvent.messages &&
              _vm.selectedEvent.messages.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "messageList",
                      on: {
                        click: function($event) {
                          return _vm.showMessages(_vm.selectedEvent)
                        }
                      }
                    },
                    [
                      _vm.selectedEvent.messages &&
                      _vm.selectedEvent.messages.length > 0
                        ? _c("div", [
                            _vm.selectedEvent.messages &&
                            _vm.selectedEvent.messages.length > 1
                              ? _c("div", { staticClass: "messageEllipsis" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-symbols-outlined"
                                    },
                                    [_vm._v("more_horiz")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "message" }, [
                              _c("div", { staticClass: "messageHeading" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.mostRecentMessage(
                                      _vm.selectedEvent.messages
                                    ).sender.givenName
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.mostRecentMessage(
                                        _vm.selectedEvent.messages
                                      ).sender.familyName
                                    ) +
                                    ", " +
                                    _vm._s(
                                      _vm.formattedDateTimeString(
                                        _vm
                                          .mostRecentMessage(
                                            _vm.selectedEvent.messages
                                          )
                                          .dateTime.toDate(),
                                        _vm.selectedEvent.location,
                                        _vm.appUser.timeZoneIdentifier
                                      )
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.appUser &&
                                    _vm.appUser.uid ==
                                      _vm.mostRecentMessage(
                                        _vm.selectedEvent.messages
                                      ).sender.userId
                                      ? "messageBody_sender"
                                      : "messageBody_notSender"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.mostRecentMessage(
                                        _vm.selectedEvent.messages
                                      ).body
                                    )
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticStyle: { position: "relative" } }, [
                  _c("img", {
                    staticClass: "colorizePrimary",
                    attrs: {
                      src: require("../assets/images/EventDetail_WhoIcon.png"),
                      width: "35",
                      height: "30"
                    }
                  }),
                  _vm._v(" "),
                  _vm.isChangeStatusSetForUserInvitation(
                    _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser),
                    _vm.$InvitationChangeStatus.inviteesAdded
                  ) ||
                  _vm.isChangeStatusSetForUserInvitation(
                    _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser),
                    _vm.$InvitationChangeStatus.inviteesRemoved
                  ) ||
                  _vm.isChangeStatusSetForUserInvitation(
                    _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser),
                    _vm.$InvitationChangeStatus.inviteesAttendanceChanged
                  )
                    ? _c("div", [
                        _c("div", {
                          staticClass: "statusDotBackground",
                          staticStyle: {
                            position: "absolute",
                            top: "-8px",
                            right: "-8px"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "statusDot",
                          staticStyle: {
                            position: "absolute",
                            top: "-5px",
                            right: "-5px"
                          }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col1" }, [
                  _c("p", { staticClass: "heading" }, [
                    _vm._v(
                      "Invitees (" +
                        _vm._s(_vm.selectedEvent.invitations.length) +
                        ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col2",
                    staticStyle: { "text-align": "right" }
                  },
                  [
                    _c("span", { staticClass: "attendanceCountIn" }, [
                      _c("img", {
                        staticClass: "colorizeAttendanceStatusAttending",
                        attrs: {
                          src: require("../assets/images/AttendanceStatusIcon_In.png"),
                          width: "16",
                          height: "16"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.eventInvitationAttendanceCount(
                              _vm.selectedEvent,
                              1
                            ) +
                              _vm.eventInvitationAttendanceCount(
                                _vm.selectedEvent,
                                2
                              ) *
                                2
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "attendanceCountOut" }, [
                      _c("img", {
                        staticClass: "colorizeAttendanceStatusNotAttending",
                        attrs: {
                          src: require("../assets/images/AttendanceStatusIcon_Out.png"),
                          width: "16",
                          height: "16"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.eventInvitationAttendanceCount(
                              _vm.selectedEvent,
                              3
                            )
                          )
                      )
                    ]),
                    _vm._v(" \n          "),
                    _c("span", { staticClass: "attendanceCountUndecided" }, [
                      _c("img", {
                        staticClass: "colorizeAttendanceStatusUndecided",
                        attrs: {
                          src: require("../assets/images/AttendanceStatusIcon_Undecided.png"),
                          width: "16",
                          height: "16"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.eventInvitationAttendanceCount(
                              _vm.selectedEvent,
                              0
                            ) +
                              _vm.eventInvitationAttendanceCount(
                                _vm.selectedEvent,
                                4
                              )
                          )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inviteeList" }, [
                _vm.selectedEvent.invitations.length
                  ? _c(
                      "div",
                      _vm._l(_vm.selectedEvent.invitations, function(
                        invitation
                      ) {
                        return _c(
                          "div",
                          { key: invitation.id, staticClass: "invitation" },
                          [
                            _c("div", { staticClass: "col1" }, [
                              invitation.invitee
                                ? _c("div", [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(invitation.invitee.givenName) +
                                          " " +
                                          _vm._s(invitation.invitee.familyName)
                                      )
                                    ])
                                  ])
                                : _c("div", [_c("p", [_vm._v("Unknown")])])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col2" }, [
                              invitation.attendanceStatus == 0
                                ? _c("img", {
                                    staticClass:
                                      "colorizeAttendanceStatusUnknown",
                                    attrs: {
                                      src: require("../assets/images/AttendanceStatusIcon_Unknown.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              invitation.attendanceStatus == 1
                                ? _c("img", {
                                    staticClass:
                                      "colorizeAttendanceStatusAttending",
                                    attrs: {
                                      src: require("../assets/images/AttendanceStatusIcon_In.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              invitation.attendanceStatus == 2
                                ? _c("img", {
                                    staticClass:
                                      "colorizeAttendanceStatusAttending",
                                    attrs: {
                                      src: require("../assets/images/AttendanceStatusIcon_InPlusOne.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              invitation.attendanceStatus == 3
                                ? _c("img", {
                                    staticClass:
                                      "colorizeAttendanceStatusNotAttending",
                                    attrs: {
                                      src: require("../assets/images/AttendanceStatusIcon_Out.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              invitation.attendanceStatus == 4
                                ? _c("img", {
                                    staticClass:
                                      "colorizeAttendanceStatusUndecided",
                                    attrs: {
                                      src: require("../assets/images/AttendanceStatusIcon_Undecided.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", [
                      _c("p", { staticClass: "emptyList" }, [
                        _vm._v("No invitees")
                      ])
                    ])
              ]),
              _vm._v(" "),
              !_vm.isEventCanceled(_vm.selectedEvent) &&
              _vm.isEventUpcomingOrNow(_vm.selectedEvent)
                ? _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser)
                        .attendanceStatus == 3
                        ? [_vm._m(0)]
                        : [
                            _c(
                              "button",
                              {
                                class: _vm.canSetEventNotAttending(
                                  _vm.selectedEvent,
                                  _vm.appUser
                                )
                                  ? "attendanceButtonOut"
                                  : "attendanceButtonOut_disabled",
                                on: {
                                  click: function($event) {
                                    _vm.canSetEventNotAttending(
                                      _vm.selectedEvent,
                                      _vm.appUser
                                    ) &&
                                      _vm.attendanceOutButtonTapped(
                                        _vm.selectedEvent,
                                        _vm.appUser
                                      )
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "colorizeBackground",
                                  attrs: {
                                    src: require("../assets/images/AttendanceStatusIcon_Out.png"),
                                    width: "32",
                                    height: "32"
                                  }
                                })
                              ]
                            )
                          ],
                      _vm._v(" "),
                      _vm.selectedEvent.settings &&
                      _vm.selectedEvent.settings.allowPlusOnes
                        ? [
                            _vm.invitationForAppUser(
                              _vm.selectedEvent,
                              _vm.appUser
                            ).attendanceStatus == 2
                              ? [_vm._m(1)]
                              : [
                                  _c(
                                    "button",
                                    {
                                      class: _vm.canSetEventAttendingPlusOne(
                                        _vm.selectedEvent,
                                        _vm.appUser
                                      )
                                        ? "attendanceButtonIn"
                                        : "attendanceButtonIn_disabled",
                                      on: {
                                        click: function($event) {
                                          _vm.canSetEventAttendingPlusOne(
                                            _vm.selectedEvent,
                                            _vm.appUser
                                          ) &&
                                            _vm.attendanceInPlusOneButtonTapped(
                                              _vm.selectedEvent,
                                              _vm.appUser
                                            )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "colorizeBackground",
                                        attrs: {
                                          src: require("../assets/images/AttendanceStatusIcon_InPlusOne.png"),
                                          width: "32",
                                          height: "32"
                                        }
                                      })
                                    ]
                                  )
                                ]
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invitationForAppUser(_vm.selectedEvent, _vm.appUser)
                        .attendanceStatus == 1
                        ? [_vm._m(2)]
                        : [
                            _c(
                              "button",
                              {
                                class: _vm.canSetEventAttending(
                                  _vm.selectedEvent,
                                  _vm.appUser
                                )
                                  ? "attendanceButtonIn"
                                  : "attendanceButtonIn_disabled",
                                on: {
                                  click: function($event) {
                                    _vm.canSetEventAttending(
                                      _vm.selectedEvent,
                                      _vm.appUser
                                    ) &&
                                      _vm.attendanceInButtonTapped(
                                        _vm.selectedEvent,
                                        _vm.appUser
                                      )
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "colorizeBackground",
                                  attrs: {
                                    src: require("../assets/images/AttendanceStatusIcon_In.png"),
                                    width: "32",
                                    height: "32"
                                  }
                                })
                              ]
                            )
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ])
          ])
        : _c("div", [
            _c("p", { staticClass: "emptyList" }, [
              _vm._v("There isn't an event")
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "attendanceButtonOut_selected" }, [
      _c("img", {
        staticClass: "colorizeAttendanceStatusNotAttending",
        attrs: {
          src: require("../assets/images/AttendanceStatusIcon_Out.png"),
          width: "32",
          height: "32"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("YOU ARE OUT")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "attendanceButtonIn_selected" }, [
      _c("img", {
        staticClass: "colorizeBackground",
        attrs: {
          src: require("../assets/images/AttendanceStatusIcon_InPlusOne.png"),
          width: "32",
          height: "32"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("YOU ARE IN+1")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "attendanceButtonIn_selected" }, [
      _c("img", {
        staticClass: "colorizeAttendanceStatusAttending",
        attrs: {
          src: require("../assets/images/AttendanceStatusIcon_In.png"),
          width: "32",
          height: "32"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("YOU ARE IN")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eb4fccc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb4fccc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Event.vue
// module id = null
// module chunks = 